import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getAppState } from '../../redux/store';
import { Message } from '../services/patientApi';
import { queryKeys } from '../queryKeys';

const getCableUrl = (token: string) => {
  const { protocol, host } = new URL((process.env.REACT_APP_PORTAL_API_ENDPOINT ?? '').trim());
  const wsProtocol = protocol === 'https:' ? 'wss:' : 'ws:';
  return `${wsProtocol}//${host}/cable?token=${token}`;
};

export const useConversationSocket = (conversationId: string | null) => {
  const token = getAppState().patientAuth.patientToken;
  const qc = useQueryClient();

  useEffect(() => {
    if (!conversationId || !token) return;

    const ws = new WebSocket(getCableUrl(token));
    const identifier = JSON.stringify({
      channel: 'PatientPortal::ConversationChannel',
      conversation_id: conversationId,
    });

    ws.onopen = () => {
      ws.send(JSON.stringify({ command: 'subscribe', identifier }));
    };

    ws.onmessage = (event) => {
      const payload = JSON.parse(event.data);
      if (payload.message?.type !== 'message.created') return;

      const newMessage: Message = payload.message.data.data;

      qc.setQueryData(queryKeys.messages.list(conversationId), (old: any) => {
        if (!old) return old;
        const [firstPage, ...rest] = old.pages;
        const alreadyExists = old.pages.some((p: any) =>
          p.items.some((m: any) => m.id === newMessage.id),
        );
        if (alreadyExists) return old;
        return {
          ...old,
          pages: [{ ...firstPage, items: [newMessage, ...firstPage.items] }, ...rest],
        };
      });
    };

    return () => ws.close();
  }, [conversationId, token, qc]);
};
